class AutomationTestJobDto {
    constructor(public automationTestJobId: number, public deploymentRequestId: number, public parentDeploymentRequestId: number, public buildId: number, public requestedDate: string, public status ? : AutomationTestJobStatus, public buildUrl ? : string, public errorMessage ? : string, public requestedBy ? : string, public testTag ? : string) {}
}
enum AutomationTestJobStatus {
    Queued = 0, WaitingForDeployment = 1, RunningTests = 2, DestroyingDeployment = 3, Complete = 4, Error = 5
}
class AutomationTestStatusCountDto {
    constructor(public status: number, public count: number, public statusName ? : string) {}
}
class AutomationTestSummaryDto {
    constructor(public totalTests: number, public successfulTests: number, public failedTests: number, public activeTests: number, public successRate: number) {}
}
class BuildInfoDto {
    constructor(public buildId: number, public status ? : string, public result ? : string, public branchName ? : string, public startTime ? : string, public finishTime ? : string, public buildUrl ? : string) {}
}
class CreateDeploymentRequestDto {
    constructor(public projectId: number, public databaseTemplateId: number, public branchName ? : string, public headSha?: string | null) {}
}
class DailyDeploymentMetricDto {
    constructor(public date: string, public totalDeployments: number, public successfulDeployments: number, public failedDeployments: number, public averageDeploymentTimeMinutes: number) {}
}
class DashboardSummaryDto {
    constructor(public totalDeployments: number, public activeDeployments: number, public successfulDeployments: number, public failedDeployments: number, public pendingDeployments: number, public successRate: number, public averageDeploymentTimeMinutes: number, public deploymentsTrendPercentage: number, public successRateTrendPercentage: number) {}
}
class DeploymentScopeMetricsDto {
    constructor(public summary ? : DashboardSummaryDto, public dailyMetrics ? : DailyDeploymentMetricDto[], public statusDistribution ? : StatusCountDto[], public recentDeployments ? : RecentDeploymentDto[], public topDeployers ? : TopDeployerDto[]) {}
}
class DeploymentMetricsByScopeDto {
    constructor(public all ? : DeploymentScopeMetricsDto, public deployments ? : DeploymentScopeMetricsDto, public automation ? : DeploymentScopeMetricsDto) {}
}
class DatabaseTemplateDto {
    constructor(public databaseTemplateId: number, public displayName ? : string, public databaseName ? : string) {}
}
class DeploymentActionControlsDto {
    constructor(public disableDeploymentsTemporarily: boolean, public disableCreateDeployment: boolean, public disableRunAutomationTests: boolean) {}
}
enum DeploymentSource {
    DevOps = 0, GitHub = 1
}
class DeploymentRequestDto {
    constructor(public deploymentRequestId: number, public requestedById: string, public requestedDate: string, public excludeFromAutoPause: boolean, public isLocked: boolean, public branchName ? : string, public branchIdentifier ? : string, public dockerTag ? : string, public requestedBy ? : string, public destroyedBy ? : string, public status ? : DeploymentStatus, public deployedDate ? : string, public lastStartedDate ? : string, public destroyedDate ? : string, public destroyRequestedDate ? : string, public errorMessage ? : string, public deploymentUrl ? : string, public parentDeploymentRequestId ? : number, public buildInfo ? : BuildInfoDto, public currentBuild ? : string, public databaseTemplateName ? : string, public deploymentSource: DeploymentSource = DeploymentSource.DevOps, public projectId: number = 0, public expiresAtUtc: string | null = null, public expiryExtensionsUsed: number = 0, public isExpiryProtected: boolean = false) {}
}
class DeploymentRequestLogDto {
    constructor(public deploymentRequestLogId: number, public deploymentRequestId: number, public timestamp: string, public message ? : string) {}
}
enum DeploymentStatus {
    PendingDeployment = 0, Deploying = 1, Deployed = 2, PendingDestroy = 3, Destroying = 4, Destroyed = 5, Error = 6, PendingDatabaseReset = 7, DatabaseResetting = 8, Pausing = 9, Paused = 10, Resuming = 11, DestroyedError = 12
}
class ForceSetDeploymentStatusDto {
    constructor(public deploymentRequestId: number, public status: DeploymentStatus) {}
}
class DeploymentCleanupResourceDto {
    constructor(public resourceKey: string, public resourceType: string, public resourceName: string, public exists: boolean | null, public existenceError ? : string) {}
}
class DeploymentCleanupJobDto {
    constructor(public jobId: string, public state: string, public method: string, public parentJobId ? : string, public createdAtUtc ? : string, public errorMessage ? : string) {}
}
class DeploymentCleanupDetailsDto {
    constructor(public deploymentRequestId: number, public status: DeploymentStatus, public resources: DeploymentCleanupResourceDto[], public jobs: DeploymentCleanupJobDto[]) {}
}
class QueueDeploymentResourceCleanupDto {
    constructor(public deploymentRequestId: number, public resourceKey: string) {}
}
class QueueDeploymentResourceCleanupResponseDto {
    constructor(public jobId ? : string) {}
}
class DeleteDeploymentCleanupJobDto {
    constructor(public deploymentRequestId: number, public jobId: string) {}
}
class GetAutomationTestJobCleanupDetailsInputDto {
    constructor(public automationTestJobId: number) {}
}
class AutomationTestJobCleanupDetailsDto {
    constructor(public automationTestJobId: number, public automationTestJobStatus: AutomationTestJobStatus, public deployment: DeploymentCleanupDetailsDto) {}
}
class QueueAutomationTestJobResourceCleanupDto {
    constructor(public automationTestJobId: number, public resourceKey: string) {}
}
class DeleteAutomationTestJobCleanupJobDto {
    constructor(public automationTestJobId: number, public jobId: string) {}
}
class FinalizeAutomationTestJobCleanupDto {
    constructor(public automationTestJobId: number) {}
}
class FinalizeAutomationTestJobCleanupResponseDto {
    constructor(public automationTestJob: AutomationTestJobDto, public deploymentRequest: DeploymentRequestDto) {}
}
class ForceSetAutomationTestJobStatusDto {
    constructor(public automationTestJobId: number, public status: AutomationTestJobStatus) {}
}
class DestroyDeploymentRequestDto {
    constructor(public deploymentRequestId: number) {}
}
class EntityTagHeaderValue {
    constructor(public isWeak: boolean, public tag ? : StringSegment) {}
}
class FileContentResult {
    constructor(public fileContents: string, public entityTag: null, public enableRangeProcessing: boolean, public contentType ? : string, public fileDownloadName ? : string, public lastModified ? : string) {}
}
class GetAutomationTestJobsInputDto {
    constructor(public deploymentRequestIds ? : number[]) {}
}
class GetAutomationTestJobsResponseDto {
    constructor(public automationTestJobs ? : AutomationTestJobDto[]) {}
}
class GetDashboardMetricsResponseDto {
    constructor(public summary ? : DashboardSummaryDto, public deploymentMetrics ? : DeploymentMetricsByScopeDto, public hangfireSummary ? : HangfireJobSummaryDto, public dailyMetrics ? : DailyDeploymentMetricDto[], public statusDistribution ? : StatusCountDto[], public recentDeployments ? : RecentDeploymentDto[], public topDeployers ? : TopDeployerDto[], public automationTestSummary ? : AutomationTestSummaryDto, public automationTestStatusDistribution ? : AutomationTestStatusCountDto[], public recentAutomationTests ? : RecentAutomationTestDto[]) {}
}
class GetDatabaseTemplatesResponseDto {
    constructor(public databaseTemplates ? : DatabaseTemplateDto[]) {}
}
class GetDeploymentRequestAdminPasswordInputDto {
    constructor(public deploymentRequestId: number) {}
}
class GetDeploymentRequestAdminPasswordResponseDto {
    constructor(public createdDateUtc: string, public password ? : string, public lastViewedDateUtc ? : string) {}
}
class GetDeploymentRequestLogsResponseDto {
    constructor(public logs ? : DeploymentRequestLogDto[]) {}
}
class GetDeploymentRequestsResponseDto {
    constructor(public requests ? : DeploymentRequestDto[], public branches ? : GitBranchDto[], public searchWarnings ? : string[]) {}
}
class GetProjectsResponseDto {
    constructor(public projects ? : ProjectDto[]) {}
}
class GitBranchDto {
    constructor(public name ? : string, public projectId: number = 0, public projectName ? : string, public deploymentSource: DeploymentSource = DeploymentSource.DevOps, public existingDeployment: import('./productivity').DeploymentConflict | null = null) {}
}
class HangfireJobSummaryDto {
    constructor(public succeededJobs: number, public failedJobs: number, public deletedJobs: number, public processingJobs: number, public enqueuedJobs: number, public scheduledJobs: number, public retryingJobs: number, public awaitingJobs: number, public successRate: number) {}
}
class HostedServiceControlsDto {
    constructor(public deploymentRequestChangedMonitorEnabled: boolean, public automationTestJobChangedMonitorEnabled: boolean, public buildStatusEnabled: boolean, public currentBuildEnabled: boolean, public deploymentRequestLogMonitorEnabled: boolean, public automationTestRunnerEnabled: boolean) {}
}
class LockDeploymentRequestDto {
    constructor(public deploymentRequestId: number) {}
}
class OperationalControlsDto {
    constructor(public hostedServices ? : HostedServiceControlsDto, public actions ? : DeploymentActionControlsDto) {}
}
class PauseDeploymentRequestDto {
    constructor(public deploymentRequestId: number) {}
}
class ProjectAdminDto {
    constructor(public projectId: number, public buildDefinitionId: number, public automationTestDefinitionId: number, public displayName ? : string, public name ? : string, public repositoryId ? : string, public deploymentConfiguration ? : string, public automationConfiguration ? : string, public isDisabled: boolean = false) {}
}
class SetProjectDisabledDto {
    constructor(public projectId: number, public isDisabled: boolean) {}
}
class ProjectDto {
    constructor(public projectId: number, public displayName ? : string, public deploymentSource: DeploymentSource = DeploymentSource.DevOps, public isDisabled: boolean = false) {}
}
class QueueReconciliationCleanupRequestDto {
    constructor(public runId ? : string, public findingKey ? : string) {}
}
class QueueReconciliationCleanupResponseDto {
    constructor(public findingKey: string, public cleanupStatus: string, public runId ? : string, public jobId ? : string, public queuedAtUtc ? : string, public message ? : string) {}
}
class RecentAutomationTestDto {
    constructor(public automationTestJobId: number, public parentDeploymentRequestId: number, public status: number, public requestedDate: string, public statusName ? : string, public requestedBy ? : string, public buildUrl ? : string, public testTag ? : string, public branchName ? : string, public projectName ? : string, public projectId: number = 0, public isProjectDeleted: boolean = false) {}
}
class RecentDeploymentDto {
    constructor(public deploymentRequestId: number, public status: number, public requestedDate: string, public branchName ? : string, public requestedBy ? : string, public statusName ? : string, public deployedDate ? : string, public projectName ? : string, public projectId: number = 0, public isProjectDeleted: boolean = false) {}
}
class ReconciliationRunScopeDto {
    constructor(public activeOnly: boolean, public deploymentRequestIds ? : number[], public projectId ? : number) {}
}
class ResetDatabaseInputDto {
    constructor(public deploymentRequestId: number, public databaseTemplateId ? : number) {}
}
class RestartAppInputDto {
    constructor(public deploymentRequestId: number) {}
}
class ResumeDeploymentRequestDto {
    constructor(public deploymentRequestId: number) {}
}
class RunAutomationTestsRequestDto {
    constructor(public deploymentRequestId: number, public testTag ? : string) {}
}
class RunAutomationTestsResponseDto {
    constructor(public existing: boolean, public buildUrl ? : string) {}
}
class RunBuildRequestDto {
    constructor(public projectId: number, public deploymentRequestId: number, public branch ? : string) {}
}
class RunBuildResponseDto {
    constructor(public existing: boolean, public buildUrl ? : string) {}
}
class RunReconciliationRequestDto {
    constructor(public deploymentRequestIds ? : number[]) {}
}
class RunReconciliationResponseDto {
    constructor(public isExistingRun: boolean, public startedAtUtc: string, public runId ? : string, public status ? : string, public scope ? : ReconciliationRunScopeDto) {}
}
class SetExcludeFromAutoPauseDto {
    constructor(public deploymentRequestId: number, public excludeFromAutoPause: boolean) {}
}
class StatusCountDto {
    constructor(public status: number, public count: number, public statusName ? : string) {}
}
class StopReconciliationRequestDto {
    constructor(public runId ? : string) {}
}
class StopReconciliationResponseDto {
    constructor(public runId ? : string, public status ? : string) {}
}
class VerifyReconciliationFindingRequestDto {
    constructor(public runId ? : string, public findingKey ? : string) {}
}
class VerifyReconciliationFindingResponseDto {
    constructor(public findingKey: string, public verificationStatus: string, public verifiedAtUtc: string, public runId ? : string, public message ? : string) {}
}
class StringSegment {
    constructor(public offset: number, public length: number, public hasValue: boolean, public buffer ? : string, public value ? : string) {}
}
class TopDeployerDto {
    constructor(public deploymentCount: number, public successfulCount: number, public failedCount: number, public requestedBy ? : string) {}
}
class UpdateOperationalControlsDto {
    constructor(public hostedServices ? : HostedServiceControlsDto, public actions ? : DeploymentActionControlsDto) {}
}
class UpdateProjectDto {
    constructor(public projectId: number, public displayName ? : string, public deploymentConfiguration ? : string, public automationConfiguration ? : string) {}
}
class WrappedResponse < T > {
    public result: T;public validationErrors: any;
}
export {
    DeploymentSource,
    WrappedResponse,
    AutomationTestJobDto,
    AutomationTestJobStatus,
    AutomationTestStatusCountDto,
    AutomationTestSummaryDto,
    BuildInfoDto,
    CreateDeploymentRequestDto,
    DailyDeploymentMetricDto,
    DashboardSummaryDto,
    DeploymentScopeMetricsDto,
    DeploymentMetricsByScopeDto,
    DatabaseTemplateDto,
    DeploymentActionControlsDto,
    DeploymentRequestDto,
    DeploymentRequestLogDto,
    DeploymentStatus,
    ForceSetDeploymentStatusDto,
    DeploymentCleanupResourceDto,
    DeploymentCleanupJobDto,
    DeploymentCleanupDetailsDto,
    QueueDeploymentResourceCleanupDto,
    QueueDeploymentResourceCleanupResponseDto,
    DeleteDeploymentCleanupJobDto,
    GetAutomationTestJobCleanupDetailsInputDto,
    AutomationTestJobCleanupDetailsDto,
    QueueAutomationTestJobResourceCleanupDto,
    DeleteAutomationTestJobCleanupJobDto,
    FinalizeAutomationTestJobCleanupDto,
    FinalizeAutomationTestJobCleanupResponseDto,
    ForceSetAutomationTestJobStatusDto,
    DestroyDeploymentRequestDto,
    EntityTagHeaderValue,
    FileContentResult,
    GetAutomationTestJobsInputDto,
    GetAutomationTestJobsResponseDto,
    GetDashboardMetricsResponseDto,
    GetDatabaseTemplatesResponseDto,
    GetDeploymentRequestAdminPasswordInputDto,
    GetDeploymentRequestAdminPasswordResponseDto,
    GetDeploymentRequestLogsResponseDto,
    GetDeploymentRequestsResponseDto,
    GetProjectsResponseDto,
    GitBranchDto,
    HangfireJobSummaryDto,
    HostedServiceControlsDto,
    LockDeploymentRequestDto,
    OperationalControlsDto,
    PauseDeploymentRequestDto,
    ProjectAdminDto,
    ProjectDto,
    QueueReconciliationCleanupRequestDto,
    QueueReconciliationCleanupResponseDto,
    RecentAutomationTestDto,
    RecentDeploymentDto,
    ReconciliationRunScopeDto,
    ResetDatabaseInputDto,
    RestartAppInputDto,
    ResumeDeploymentRequestDto,
    RunAutomationTestsRequestDto,
    RunAutomationTestsResponseDto,
    RunBuildRequestDto,
    RunBuildResponseDto,
    RunReconciliationRequestDto,
    RunReconciliationResponseDto,
    SetExcludeFromAutoPauseDto,
    StatusCountDto,
    StopReconciliationRequestDto,
    StopReconciliationResponseDto,
    VerifyReconciliationFindingRequestDto,
    VerifyReconciliationFindingResponseDto,
    StringSegment,
    TopDeployerDto,
    UpdateOperationalControlsDto,
    UpdateProjectDto,
    SetProjectDisabledDto
}
